import React, {Component} from "react"
import request from "../../utils/request";
import DataTable from "react-data-table-component";
import {observer} from "mobx-react";
import patient from "../../stores/patient";
function calculateMonday(sundayDateStr) {
  // Create a Date object from the provided date string
  const sunday = new Date(sundayDateStr);

  // Calculate Monday by subtracting 6 days from Sunday
  sunday.setDate(sunday.getDate() - 6);

  // Return the date as a string in yyyy-mm-dd format
  return sunday.toISOString().split('T')[0];
}
@observer
export class OverallSummary extends Component {
  state = {
    reports: []
  };

  componentDidMount() {
    this.fetchReports().then();
  }

  fetchReports = async () => {
    const res = await request('/api/adherenceStats/getOverallReports', {
      patientID: patient.fields._id,
    });

    if(res.success) {
      this.setState({reports: res.data.overallReports});
    } else {
      console.error('fetch overall summary reports failed');
    }
  }

  render() {
    const columns = [
      {
        name: 'Date Range (Week)',
        selector: row => `${calculateMonday(row.sunday_stop)} to ${row.sunday_stop}`,
        sortable: true,
      },
      {
        name: 'Adherence Rate',
        selector: row => `${(row.perc_overall_adherent).toFixed(2)}%`,
        sortable: true,
      },
    ];

    return (
      <DataTable
        title="Overall Adherence Report"
        columns={columns}
        data={this.state.reports}
        defaultSortField="startDate"
        pagination
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AdherenceStats/OverallSummary.jsx